import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import {FlujoVentaPaso} from '../../../_models/flujo-venta-paso';
import {TabViewCustom} from '../../../_models/tab-view-custom';

@Component( {
  selector: 'app-flujo-venta-oferta',
  templateUrl: 'flujo-venta-oferta.component.html'
} )

export class FlujoVentaOfertaComponent implements OnInit {

  @Input() tabView: TabViewCustom;
  @Input() listaSecuencias: SelectItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listaTiposPersonas: SelectItem[] = [];
  @Input() secFija: boolean;
  @Input() lisPasos: FlujoVentaPaso[] = [];
  @Output() actualizarSecuencia: EventEmitter<any> = new EventEmitter<any>();
  @Input() titulo: string;
  tabSeleccionado = 'DATGEN';

  constructor() {
  }

  ngOnInit() {
  }

  abrirAcordeon( evento: number ) {
    switch ( evento ) {
      case 0: {
        this.tabSeleccionado = 'DATGEN';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'RESPERXVIN';
        break;
      }
    }
  }
}
